import { graphql } from 'src/gql'
import { StaffingAgenciesQueryVariables, SortFindManyDistribution_SubcategoryInput } from 'src/gql/graphql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL, UseGraphqlOptions } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query staffingAgencies($sort: SortFindManyDistribution_SubcategoryInput, $filter: FilterFindManyDistribution_SubcategoryInput, $limit: Int) {
    cat {
      distributionSubcategory {
        many(sort: $sort, filter: $filter, limit: $limit) {
          _id
          name
          _status {
            _id
            name 
            color
          }
          staffingAgency {
            sdvosb
          }
          position_count
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type StaffingAgencies = NonNullable<NonNullable<NonNullable<NonNullable<TData>['cat']>['distributionSubcategory']>['many']>

const useStaffingAgencies = (variables?: StaffingAgenciesQueryVariables, options?: UseGraphqlOptions<TData>, enabled: boolean = true): StaffingAgencies => {
  const internalVariables: StaffingAgenciesQueryVariables = Object.assign({
    filter: {
      category: '5fb838d758925134f0b4ac86' // Staffing Agencies Category ID
    },
    sort: SortFindManyDistribution_SubcategoryInput.NameAsc,
    limit: 1000
  }, variables)
  const { data } = useGraphQL(document, internalVariables, options)
  return data?.cat?.distributionSubcategory?.many ?? []
}

export { useStaffingAgencies, document as staffingAgenciesDocument }
